// JobPost.jsx
import React from 'react';
import JobPostingForm from './JobPostingForm';

function Search() {
  return (
    // <div className="min-w-full items-center justify-center bg-white-500">
    <div className="w-full bg-white p-auto">
      <JobPostingForm />
      <div className="mt-3 flex justify-end">
        <button className="bg-[#0077B5] text-white font-bold py-2 px-4 rounded">
          Submit Job Posting 
        </button>
      </div>
    </div>
    // </div>
  );
}

export default Search;
